import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { closeModal } from "../../redux/features/modalSlice";
import { STATUS_OPTIONS } from '../../Constant/leadConstent';
import { updateLead, getLeadDetails, } from "../../redux/services/leadServices/Lead.Services";
import { allactivestaff } from "../../redux/services/Staff Services/Staff.Services";
import { ActiveUserList } from "../../redux/services/User Services/User.Services"
function EditLead({ data }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [vendors, setVendors] = useState([]);
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        mobile: "",
        vendor_id: "",
        alternate_mobile: "",
        email: "",
        company_name: "",
        source: "",
        source_type: "",
        status: "",
        sub_status: "",
        assigned_to: "",
        // priority: "",

        lead_category: "",
        lead_stage: "",

        city: "",
        state: "",
        area: "",
        pincode: "",

        address: "",

        date: "",
        time: "",

        estimate_amount: "",

        reference: "",

        remarks: "",

        call_outcome: "",

        message: "",
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {

        fetchUsers();
        fetchLead();

    }, []);

    const fetchUsers = async () => {
        try {
            const res = await allactivestaff();
            setUsers(res?.data || []);
        } catch (error) {
            console.log("Staff API Error:", error);
        }
    };
    useEffect(() => {
        const fetchVendor = async () => {
            try {
                const res = await ActiveUserList();
                setVendors(res?.data || []);
            } catch (error) {
                console.log("Staff API error:", error);
            }
        };
        fetchVendor();
    }, []);
    const fetchLead = async () => {
        try {
            const res = await getLeadDetails(id);

            console.log(res);

            const lead = res?.data;

            setFormData({
                id: lead?.id || "",
                lead_id: lead?.lead_id || "",
               vendor_id: lead?.vendor_details?.id || "",
                name: lead?.name || "",
                mobile: lead?.mobile || "",
                alternate_mobile: lead?.alternate_mobile || "",
                email: lead?.email || "",
                company_name: lead?.company_name || "",
                source: lead?.source || "",
                status: lead?.status || "",
                sub_status: lead?.sub_status || "",
                assigned_to: lead?.assigned_to || "",
                // priority: lead?.priority || "",
                lead_category: lead?.lead_category || "",
                lead_stage: lead?.lead_stage || "",
                city: lead?.city || "",
                state: lead?.state || "",
                area: lead?.area || "",
                pincode: lead?.pincode || "",
                address: lead?.address || "",
                date: lead?.date || "",
                time: lead?.time || "",
                estimate_amount: lead?.estimate_amount || "",
                reference: lead?.reference || "",
                remarks: lead?.remarks || "",
                call_outcome: lead?.call_outcome || "",
                message: lead?.message || "",
                assigned_by: lead?.assign_by?.name || "",
                created_at: lead?.created_at || "",
                updated_at: lead?.updated_at || "",
            });
        } catch (error) {
            console.log(error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const validate = () => {
        let newErrors = {};

        if (!formData.mobile.trim()) {
            newErrors.mobile = "Mobile number is required";
        } else if (!/^\d{10}$/.test(formData.mobile.trim())) {
            newErrors.mobile = "Mobile number must be exactly 10 digits";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        setLoading(true);

        try {
            const payload = {
                id: Number(id),

                name: formData.name?.trim(),
               vendor_id: formData.vendor_id ? Number(formData.vendor_id) : null,
                mobile: formData.mobile?.trim(),

                alternate_mobile:
                    formData.alternate_mobile?.trim(),

                email: formData.email?.trim(),

                company_name:
                    formData.company_name?.trim(),

                source: formData.source,

                source_type: formData.source_type,

                status: formData.status,

                sub_status: formData.sub_status,

                assigned_to: formData.assigned_to
                    ? Number(formData.assigned_to)
                    : null,

                // priority: formData.priority,

                lead_category:
                    formData.lead_category?.trim(),

                lead_stage:
                    formData.lead_stage?.trim(),

                city: formData.city?.trim(),

                state: formData.state?.trim(),

                area: formData.area?.trim(),

                pincode: formData.pincode?.trim(),

                address: formData.address?.trim(),

                date: formData.date,

                time: formData.time,

                estimate_amount:
                    formData.estimate_amount
                        ? Number(formData.estimate_amount)
                        : null,

                reference:
                    formData.reference?.trim(),

                remarks:
                    formData.remarks?.trim(),

                call_outcome:
                    formData.call_outcome?.trim(),

                message:
                    formData.message?.trim(),
            };

            const res = await updateLead(payload);

            Swal.fire({
                icon: "success",
                title: "Success",
                text: res?.message || "Lead Updated Successfully",
            });



            navigate(-1);
        } catch (error) {
            console.log(error);

            if (error?.response?.data?.errors) {
                const backendErrors = {};

                Object.keys(error.response.data.errors).forEach((key) => {
                    backendErrors[key] = error.response.data.errors[key][0];
                });

                setErrors(backendErrors);
            }

            Swal.fire({
                icon: "error",
                title: "Error",
                text:
                    error?.response?.data?.message ||
                    error?.message ||
                    "Something went wrong",
            });
        } finally {
            setLoading(false);
        }
    };


    return (
        <>

            <div className="d-md-flex d-block align-items-center justify-content-between  page-header-breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">Lead Update</h4>

                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>

                            <li className="breadcrumb-item active">
                                Lead Details
                            </li>
                        </ol>
                    </nav>
                </div>

                <div>
                    <button
                        className="add-btn"
                        onClick={() => navigate(-1)}
                    >
                        Back To Lead List
                    </button>
                </div>
            </div>
            <div className="main_page">

                <div className="card">

                    <div className="card-body">

                        <div className="row">

                            <div className="col-md-6 mb-3">
                                <label>Source</label>
                                <select
                                    className="form-select"
                                    name="source"
                                    value={formData.source}
                                    onChange={handleChange}
                                >
                                    <option value="Website">Website</option>
                                    <option value="Facebook">Facebook</option>
                                    <option value="Google">Google</option>
                                    <option value="Instagram">Instagram</option>
                                    <option value="IndiaMART">IndiaMART</option>
                                    <option value="Justdial">Justdial</option>
                                </select>
                            </div>

                            <div className="col-md-6 mb-3">
                                <label>Assign User</label>
                                <select
                                    className="form-select"
                                    name="assigned_to"
                                    value={formData.assigned_to}
                                    onChange={handleChange}
                                >
                                    <option value="">Select User</option>

                                    {users.map((user) => (
                                        <option key={user.id} value={user.id}>
                                            {user.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label>Select Vendor</label>
                                <select
                                    className="form-select"
                                    name="vendor_id"
                                    value={formData.vendor_id}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Vendor</option>
                                    {vendors.map((vendor) => (
                                        <option key={vendor.id} value={vendor.id}>
                                            {vendor.name||vendor.mobile}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label>Customer Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label>
                                    Mobile <span className="text-danger">*</span>
                                </label>

                                <input
                                    type="text"
                                    className={`form-control ${errors.mobile ? "is-invalid" : ""
                                        }`}
                                    name="mobile"
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    maxLength={10}
                                />

                                {errors.mobile && (
                                    <div className="invalid-feedback">
                                        {errors.mobile}
                                    </div>
                                )}
                            </div>
                            {/* Lead ID */}
                            <div className="col-md-6 mb-3">
                                <label>Lead ID</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData.lead_id}
                                    readOnly
                                />
                            </div>





                            {/* Status */}
                            {/* <div className="col-md-4 mb-3">
                            <label>Status</label>
                            <input
                                type="text"
                                className="form-control"
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            />
                        </div> */}

                            <div className="col-md-6 mb-3">
                                <label>Status</label>

                                <select
                                    className="form-select"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Status</option>

                                    {STATUS_OPTIONS.map((status) => (
                                        <option
                                            key={status.value}
                                            value={status.value}
                                        >
                                            {status.value}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            {/* Priority */}
                            {/* <div className="col-md-6 mb-3">
                                <label>Priority</label>
                                <select
                                    className="form-select"
                                    name="priority"
                                    value={formData.priority}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Priority</option>
                                    <option value="Low">Low</option>
                                    <option value="Medium">Medium</option>
                                    <option value="High">High</option>
                                </select>
                            </div> */}

                            {/* Lead Category */}
                            {/* <div className="col-md-6 mb-3">
                                <label>Lead Category</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="lead_category"
                                    value={formData.lead_category}
                                    onChange={handleChange}
                                />
                            </div> */}

                            {/* Lead Stage */}
                            {/* <div className="col-md-6 mb-3">
                                <label>Lead Stage</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="lead_stage"
                                    value={formData.lead_stage}
                                    onChange={handleChange}
                                />
                            </div> */}

                            {/* City */}
                            {/* <div className="col-md-3 mb-3">
                                <label>City</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                />
                            </div> */}

                            {/* State */}
                            {/* <div className="col-md-3 mb-3">
                                <label>State</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                />
                            </div> */}

                            {/* Area */}
                            {/* <div className="col-md-3 mb-3">
                                <label>Area</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="area"
                                    value={formData.area}
                                    onChange={handleChange}
                                />
                            </div> */}

                            {/* Pincode */}
                            {/* <div className="col-md-3 mb-3">
                                <label>Pincode</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="pincode"
                                    value={formData.pincode}
                                    onChange={handleChange}
                                />
                            </div> */}

                            {/* Follow Up Time */}
                            <div className="col-md-6 mb-3">
                                <label>Follow Up Time</label>
                                <input
                                    type="time"
                                    className="form-control"
                                    name="time"
                                    value={formData.time}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Call Outcome */}
                            {/* <div className="col-md-6 mb-3">
                            <label>Call Outcome</label>
                            <input
                                type="text"
                                className="form-control"
                                name="call_outcome"
                                value={formData.call_outcome}
                                onChange={handleChange}
                            />
                        </div> */}

                            {/* Message */}
                            {/* <div className="col-md-12 mb-3">
                                <label>Message</label>
                                <textarea
                                    rows="3"
                                    className="form-control"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </div> */}



                            {/* Created At */}
                            {/* <div className="col-md-4 mb-3">
                            <label>Created At</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.created_at}
                                readOnly
                            />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label>Updated At</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.updated_at}
                                readOnly
                            />
                        </div> */}
                            <div className="col-md-6 mb-3">
                                <label>Follow-Up Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="date"
                                    value={formData.date}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label>Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label>Company Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="company_name"
                                    value={formData.company_name}
                                    onChange={handleChange}
                                />
                            </div>





                            {/* <div className="col-md-12 mb-3">
                                <label>Address</label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                />
                            </div> */}

                            <div className="col-md-12 mb-3">
                                <label>Remarks</label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    name="remarks"
                                    value={formData.remarks}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                    </div>

                    <div className="d-flex justify-content-end my-3 mx-2">
                        <button
                            type="button"
                            className="btn btn-success ms-2"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? "Updating..." : "Update Lead"}
                        </button>
                        {/* CANCEL */}
                        <button
                            className="add-btn ms-2"
                            onClick={() => dispatch(closeModal())}
                        >
                            Cancel
                        </button>




                    </div>
                </div>
                {/* BUTTONS */}
            </div>


        </>
    );
}

export default EditLead;